import { browserHistory } from 'utils/navigation'
import { injectReducers } from 'store/reducers'
import { setPageTitle, getUserRoleByStudy } from 'utils/misc'
import { USER_ROLES_MAP } from 'utils/constants'
import { UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'
import LockRedirect from 'containers/lockContainers'
import reducer, { actions as createUserActions } from './modules/CreateUser'
import sitesReducer, { fetchSites } from '../../../Sites/routes/SitesPage/modules/Sites'
import UserView from './containers/UserContainer'
import { getStudyVersionID } from '../../../../../../../../utils/studyConfigUtils'
// Sync route definition
export default store => ({
  path: 'create',
  getComponent(nextState, cb) {
    const { study, user } = store.getState()
    const studyVersionID = getStudyVersionID(store.getState()?.location)
    const { currentStudy } = study
    const { id, config } = currentStudy
    const { root, dchAdmin, dchPii } = USER_ROLES_MAP
    const isRootOrDCH = [root, dchAdmin, dchPii].includes(getUserRoleByStudy(user, id))
    if (!isRootOrDCH) {
      const canEditUsers = config ? config?.users?.can_edit_users ?? true : true
      if (!canEditUsers) {
        browserHistory.push(`/studies/${id}/${studyVersionID}/users`)
        return
      }
    }
    require.ensure(
      [],
      () => {
        const { params } = nextState
        const { studyID, studyVersionID } = params
        injectReducers(store, {
          userReducer: reducer,
          sites: sitesReducer,
        })
        store.dispatch(fetchSites(studyID, true, false, true, false))
        store.dispatch(createUserActions.resetUserPage())

        setPageTitle(`Create User | Study ${studyID} | ${currentStudy.platform_name}`)
        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              LockRedirect(
                studyID,
                studyVersionID,
                'users',
              )(UserHasScope(['wu'], UserView, false, studyID, null, currentStudy)),
            ),
          ),
        )
      },
      'create',
    )
  },
})
